//* 조문객용 부고문자 컴포넌트
import { FC } from 'react';

import { BugoData } from '@shared/api/bugo/bugo.interface';
import { fileBucketUrl } from '@shared/utils/fileUtils';
import _ from 'lodash';
import topLogo from 'src/assets/logo/topLogo.png';

import { ObituaryLayout } from './ObituaryLayout';

interface Props {
  bugo: BugoData;
  forMember?: boolean;
}

const Obituary: FC<Props> = function Obituary({ bugo, forMember }: Props) {
  const hardCustomConfig = bugo.fevent.hardCustomConfig;
  const useCustomConfig = hardCustomConfig?.useCustomConfig === true;
  const bugoBrand = bugo.bugoBrand;
  //* 조의금 사절은 지도사도 켜는 항목이라 꾸미기(useCustomConfig)와 무관하게 적용한다
  const condolenceMoneyProps = {
    hideCondolenceMoney: hardCustomConfig?.hideCondolenceMoney === true,
    condolenceMoneyMessage: hardCustomConfig?.condolenceMoneyMessage,
  };

  const bugoBrandAgencyIndex = bugo.fevent.bugoBrandAgencyIndex;

  const headerImage =
    !_.isNil(bugoBrandAgencyIndex) && bugo.bugoBrand?.bugoAgencyList
      ? bugo.bugoBrand?.bugoAgencyList[bugoBrandAgencyIndex]?.headerImage?.url
        ? fileBucketUrl(
            bugo.bugoBrand?.bugoAgencyList[bugoBrandAgencyIndex]?.headerImage
              ?.url as unknown as string,
            'w400',
          )
        : null
      : bugo.bugoBrand?.bugoAgency?.headerImage?.url
      ? fileBucketUrl(bugo.bugoBrand?.bugoAgency?.headerImage?.url, 'w400')
      : topLogo;

  const footerImage =
    !_.isNil(bugoBrandAgencyIndex) &&
    bugo.bugoBrand?.bugoAgencyList &&
    bugo.bugoBrand?.bugoAgencyList[bugoBrandAgencyIndex]?.footerImage?.url
      ? fileBucketUrl(
          bugo.bugoBrand?.bugoAgencyList[bugoBrandAgencyIndex]?.footerImage
            ?.url as unknown as string,
          'w400',
        )
      : bugo.bugoBrand?.bugoAgency?.footerImage?.url
      ? fileBucketUrl(bugo.bugoBrand?.bugoAgency?.footerImage?.url, 'w1080')
      : null;

  if (useCustomConfig) {
    return (
      <ObituaryLayout
        bugo={bugo}
        forMember={forMember}
        logoImage={
          hardCustomConfig?.headerImage
            ? fileBucketUrl(hardCustomConfig.headerImage.url, 'raw')
            : headerImage
        }
        footerImage={
          hardCustomConfig?.footerImage
            ? fileBucketUrl(hardCustomConfig.footerImage.url, 'raw')
            : footerImage
        }
        footerLink={bugoBrand?.bugoAgency?.homepageUrl}
        showFlower={hardCustomConfig?.hideFlowerOrderLink !== true}
        emptyAccountMessage={hardCustomConfig?.emptyAccountMessage}
        {...condolenceMoneyProps}
      />
    );
  }

  return (
    <ObituaryLayout
      bugo={bugo}
      forMember={forMember}
      logoImage={headerImage}
      footerImage={footerImage}
      footerLink={bugoBrand?.bugoAgency?.homepageUrl}
      showFlower={true}
      {...condolenceMoneyProps}
    />
  );
};

export default Obituary;
